import { render, staticRenderFns } from "./cart-expense-description.vue?vue&type=template&id=a1ace66a&"
import script from "./cart-expense-description.vue?vue&type=script&lang=js&"
export * from "./cart-expense-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports